const ErrorText = ({ error }) => {
  if (!error) {
    return null;
  }

  return <span className="text-error">{error}</span>;
};

export default ErrorText;
